import { useMutation } from '@tanstack/react-query';
import { showCaseService } from 'v2/services/showcase';
import type { IRating } from 'v2/services/showcase';

export const useRateProducer = (producerId: number) => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (rating: IRating) => showCaseService.rateProducer(producerId, rating)
  });

  return {
    rateProducer: (rating: IRating) => mutateAsync(rating),
    isRateProducerPending: isPending
  };
};
